import { useAuthenticator } from '@aws-amplify/ui-react';

export const useAuthenticated = () => {
  const { authStatus } = useAuthenticator((context) => [context.user, context.route]);
  const isAuthenticated = authStatus === 'authenticated';
  const isAuthConfiguring = authStatus === 'configuring';

  return { isAuthenticated, isAuthConfiguring };
};
